// This file contains props that are shared among all the snui V2 components
module.exports = {
  snInputProps_attach: {
    type: Boolean,
    default: true,
    required: false
  },
  snInputProps_autofocus: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_classes: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_deletableChips: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_disabled: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_errorMessages: {
    type: [String, Array],
    default: '',
    required: false
  },
  snInputProps_hint: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_hideDetails: {
    type: [Boolean, String],
    default: false,
    required: false
  },
  snInputProps_identifier: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_innerIcon: {
    type: String,
    default: null,
    required: false
  },
  snInputProps_inputMode: {
    type: String,
    default: 'text',
    required: false
  },
  snInputProps_label: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_mask: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_max: {
    type: String,
    default: null,
    required: false
  },
  snInputProps_maxLength: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_min: {
    type: String,
    default: null,
    required: false
  },
  snInputProps_multiple: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_name: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_pattern: {
    type: String,
    default: null,
    required: false
  },
  snInputProps_placeholder: {
    type: String,
    default: '',
    required: false
  },
  snInputProps_required: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_rules: {
    type: Array,
    default: () => [],
    required: false
  },
  snInputProps_smallChips: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_type: {
    type: String,
    default: 'text',
    required: false
  },
  snInputProps_validateOnBlur: {
    type: Boolean,
    default: false,
    required: false
  },
  snInputProps_pendo: {
    type: String,
    default: null,
    required: false
  }
}
